import { ApiClient } from '@listening/api-contract/api-client-tag';
import { Effect } from 'effect';
import type { PlaybackChunk } from '../query/tts-chunks';
import { getDocPackPlaybackAnchorForPosition } from './timing-index';

export type PlaybackProgress = {
  audioId: string;
  chapterId: string | null;
  ttsId: string | null;
  timestampMs: number;
  docPackPage: number | null;
  docPackCharStart: number | null;
  docPackCharEnd: number | null;
};

export const playbackProgressTimestampMs = (positionMs: number) =>
  Math.max(0, Math.round(Number.isFinite(positionMs) ? positionMs : 0));

export function playbackProgressAt({
  audioId,
  chunk,
  chapterId,
  ttsId,
  positionMs,
}: {
  audioId: string;
  chunk: PlaybackChunk | undefined;
  chapterId: string | undefined;
  ttsId: string | undefined;
  positionMs: number;
}) {
  if (!chunk) return undefined;
  const timestampMs = playbackProgressTimestampMs(positionMs);
  if (chunk.playbackMode === 'doc-pack') {
    const anchor = getDocPackPlaybackAnchorForPosition(chunk, positionMs);
    if (!anchor) return undefined;
    return {
      audioId,
      chapterId: null,
      ttsId: null,
      timestampMs,
      docPackPage: anchor.page,
      docPackCharStart: anchor.charStart,
      docPackCharEnd: anchor.charEnd,
    };
  }
  if (!chapterId) return undefined;
  return {
    audioId,
    chapterId,
    ttsId: ttsId ?? null,
    timestampMs,
    docPackPage: null,
    docPackCharStart: null,
    docPackCharEnd: null,
  };
}

export const savePlaybackProgress = Effect.fn('savePlaybackProgress')(
  function* (progress: PlaybackProgress, progressAgeMs?: number) {
    const api = yield* ApiClient;
    yield* api.Audio.UpdateAudioProgress({
      params: { audioId: progress.audioId },
      payload: {
        timestamp_ms: progress.timestampMs,
        chapter_id: progress.chapterId,
        tts_id: progress.ttsId,
        doc_pack_page: progress.docPackPage,
        doc_pack_char_start: progress.docPackCharStart,
        doc_pack_char_end: progress.docPackCharEnd,
        ...(progressAgeMs === undefined
          ? {}
          : { progress_age_ms: progressAgeMs }),
      },
    });
  },
);
